/**
 * General Audit Log Service
 * Frontend service för att hämta audit log
 */

import api from '../api/client';

export interface AuditLogEntry {
  id: number;
  user_id: string;
  username: string;
  user_email?: string;
  user_role?: string;
  entity_type: string;
  entity_id: string;
  entity_name?: string;
  action: 'CREATE' | 'UPDATE' | 'DELETE';
  changes?: Record<string, any>;
  changed_fields?: string[];
  old_values?: Record<string, any>;
  new_values?: Record<string, any>;
  ip_address?: string;
  user_agent?: string;
  request_id?: string;
  created_at: string;
}

export interface AuditLogFilters {
  userId?: string;
  entityType?: string;
  entityId?: string;
  action?: 'CREATE' | 'UPDATE' | 'DELETE';
  dateFrom?: string;
  dateTo?: string;
  search?: string;
}

export interface AuditLogResponse {
  success: boolean;
  data: AuditLogEntry[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
  };
}

export interface AuditLogStatistics {
  total: number;
  byAction: Record<string, number>;
  byEntityType: Record<string, number>;
  byUser: Array<{ userId: string; username: string; count: number }>;
}

export const generalAuditLogService = {
  /**
   * Hämta audit log
   */
  async getAuditLog(
    filters: AuditLogFilters = {},
    limit: number = 100,
    offset: number = 0
  ): Promise<AuditLogResponse> {
    const params = new URLSearchParams();
    if (filters.userId) params.append('userId', filters.userId);
    if (filters.entityType) params.append('entityType', filters.entityType);
    if (filters.entityId) params.append('entityId', filters.entityId);
    if (filters.action) params.append('action', filters.action);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.append('dateTo', filters.dateTo);
    if (filters.search) params.append('search', filters.search);
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    const response = await api.get(`/api/sysadmin/audit-log?${params.toString()}`);
    return response.data;
  },

  /**
   * Hämta statistik
   */
  async getStatistics(
    dateFrom?: string,
    dateTo?: string
  ): Promise<{ success: boolean; data: AuditLogStatistics }> {
    const params = new URLSearchParams();
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);

    const response = await api.get(
      `/api/sysadmin/audit-log/statistics?${params.toString()}`
    );
    return response.data;
  },
};

